export default {
    'setRedisChange' (context:any, value:any) {
        context.commit('setRedisChange', value);
    },
};
